import {

  lazy,

  Suspense,

  useState,

  useEffect,

  useLayoutEffect,

  useRef,

} from "react";

import { Route, Routes, useLocation, useNavigate, Navigate } from "react-router-dom";

import {

  MainContainer,

  ContentContainer,

  SideMenuContainer,

  RouteContainer,

} from "./style";

import { localStorageConstants, paths } from "../utils/constants";

import SideMenu from "../components/sideMenu";

import { ContentProvider } from "../context/useContentContext";

import { ImageDataProvider } from "../context/useImageDataContext";

import { PreviewProvider } from "../context/usePreviewContext";

import { useCloudPContent } from "../context/useCPContentContext";

import { useSidemenu } from "../context/useSideMenuContext";

import { Provider } from "react-redux";

import { persistedStore, store } from "../redux/store";

import { PersistGate } from "redux-persist/lib/integration/react";

import { useIsMobile } from "../hooks/useIsMobile";

import Drawer from "@mui/material/Drawer";



const LoginPage = lazy(() => import("../pages/login"));

const Dashboard = lazy(() => import("../pages/dashboard"));

const GraphicalDashboard = lazy(() => import("../pages/graphicalDashboard"));

const ContentDashboard = lazy(() => import("../pages/contentGraphicalDashboard"));

const Geodistribution = lazy(() => import("../pages/geodistribution"));

const UserDataDashboard = lazy(() => import("../pages/userDataDashboard"));

const UserActivityDashboard = lazy(() => import("../pages/userActivityDashboard"));

const PlaybackAnalytics = lazy(() => import("../pages/playbackAnalytics"));

const DevicePlatformAnalytics = lazy(() => import("../pages/DevicePlatformAnalytics"));

const SubscriptionRevenueAnalytics = lazy(() => import("../pages/SubscriptionRevenueAnalytics"));

const ContentAnalyticsNew = lazy(() => import("../pages/ContentAnalytics"));
//const UniverseAnalytics = lazy(() => import("../pages/universeAnalytics"));
const EventsPage = lazy(() => import("../pages/events"));
const UserLifecyclePage = lazy(() => import("../pages/userLifecycle"));
const MetricsDashboardPage = lazy(() => import("../pages/metricsDashboard"));
const AuthenticationAndOnboarding = lazy(() => import("../pages/AuthenticationAndOnboarding"));
const AiGenerationPage = lazy(() => import("../pages/AiGeneration"));
const AiToolActionsPage = lazy(() => import("../pages/AiToolActions"));
const AiToolsPage = lazy(() => import("../pages/AiTools"))
const ContentEventPage = lazy(() => import("../pages/ContentEvent"));
const SubscriptionAndRevenueEventpage = lazy(() => import("../pages/SubscriptionAndRevenueEvent"));
const WalletAndRewardsPage = lazy(() => import("../pages/WalletAndRewards"));
const NotificationsPage = lazy(() => import("../pages/Notifications"));
const DeviceAndPlatformPage = lazy(() => import("../pages/DeviceAndPlatform"));
const ContentEngagementPage = lazy(() => import("../pages/ContentEngagement"));
const CreatorPage = lazy(() => import("../pages/Creator"));
const DiscoveryPage = lazy(() => import("../pages/Discovery"));
const SearchPage = lazy(() => import("../pages/search"));
const EditSuitePage = lazy(() => import("../pages/EditSuite"));
const SettingsAndProfilePage = lazy(() => import("../pages/SettingsAndProfile"));
const DashboardNavigationPage = lazy(() => import("../pages/DashboardNavigation"));
const MatrixWalletAndRewardPage = lazy(() => import("../pages/MatrixWalletAndReward"));
const MatrixCoreEngagementPage = lazy(() => import("../pages/MatrixCoreEngagement"));
const MatrixAiGenerationPage = lazy(() => import("../pages/MatrixAiGeneration"));
const MatrixContentAndEngagementPage = lazy(() => import("../pages/MatrixContentAndEngagement"));
const MatrixCreatorAnalyticsPage = lazy(() => import("../pages/MatrixCreatorAnalytics"));
const MatrixSubscribtionAndRevenuePage = lazy(() => import("../pages/MatrixSubscribtionAndRevenue"));
const MatrixAuthenticationAndOnboardingPage = lazy(() => import("../pages/MatrixAuthenticationAndOnboarding"));
const MatrixNotificationsAndReengagementPage = lazy(() => import("../pages/MatrixNotificationsAndReengagement"));





const RoutesComponent = () => {

  const storedUser = localStorage.getItem(localStorageConstants.USER_NAME);

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(!!storedUser);

  const [activeMenu, setActiveMenu] = useState<string>(paths.METRICS_DASHBOARD);

  const navigate = useNavigate();

  const isMobile = useIsMobile();

  const { pathname } = useLocation();

  const { currentTab, setCurrentTab, isError } = useCloudPContent();

  const routeContainerRef = useRef<HTMLDivElement>(null);

  const { isOTTPlatform, setIsOTTPlatform, isMobileMenuOpen,

    setIsMobileMenuOpen } = useSidemenu();



  useEffect(() => {

    if (storedUser) {

      setIsLoggedIn(true);

    } else {

      setIsLoggedIn(false);

      navigate(paths.LOGIN);

    }

  }, [storedUser]);





  useEffect(() => {

    if (routeContainerRef.current) {

      routeContainerRef.current.scrollTop = 0;

    }

  }, [isError]);



  useLayoutEffect(() => {

    currentTab && setCurrentTab(0);

    !isOTTPlatform && setIsOTTPlatform(true);

  }, [pathname]);



  if (!isLoggedIn) {

    return (

      <Routes>

        <Route path={paths.LOGIN} element={<LoginPage />} />

      </Routes>

    );

  }



  return (

    <ContentProvider>

      <ImageDataProvider>

        <PreviewProvider>

          <MainContainer>

            <ContentContainer>

              {isMobile ? (

                <Drawer

                  anchor="left"

                  open={isMobileMenuOpen}

                  onClose={() => setIsMobileMenuOpen(false)}

                >

                  <SideMenu

                    activeRoute={activeMenu}

                    setActiveRoute={setActiveMenu}

                    closeMenu={() => setIsMobileMenuOpen(false)}

                  />

                </Drawer>

              ) : (

                <SideMenuContainer>

                  <SideMenu

                    activeRoute={activeMenu}

                    setActiveRoute={setActiveMenu}

                  />

                </SideMenuContainer>

              )}





              <RouteContainer ref={routeContainerRef}>

                <Provider store={store}>

                  <PersistGate persistor={persistedStore}>

                    <Suspense>

                      <Routes>

                        <Route path={paths.HOME} element={<Navigate to={paths.METRICS_CORE_ENGAGEMENT} replace />} />



                        <Route path={paths.DASHBOARD} element={<Dashboard />} />

                        <Route path={paths.GRAPH_DASHBOARD} element={<GraphicalDashboard />} />

                        <Route path={paths.CONTENT_DASHBOARD} element={<ContentDashboard />} />

                        <Route path={paths.GEOGRAPHIC_DASHBOARD} element={<Geodistribution />} />

                        <Route path={paths.USER_DATA_DASHBOARD} element={<UserDataDashboard />} />

                        <Route path={paths.USER_ACTIVITY_DASHBOARD} element={<UserActivityDashboard />} />

                        <Route path={paths.PLAYBACK_ANALYTICS} element={<PlaybackAnalytics />} />

                        <Route path={paths.DEVICE_PLATFORM_ANALYTICS} element={<DevicePlatformAnalytics />} />

                        <Route path={paths.SUBSCRIPTION_REVENUE_ANALYTICS} element={<SubscriptionRevenueAnalytics />} />

                        <Route path={paths.CONTENT_ANALYTICS} element={<ContentAnalyticsNew />} />
                        {/* <Route path={paths.UNIVERSE_ANALYTICS} element={<UniverseAnalytics />} /> */}

                        <Route path={paths.EVENTS} element={<EventsPage />} />
                        <Route path={paths.EVENTS_USER_LIFECYCLE} element={<UserLifecyclePage />} />
                        <Route path={paths.EVENTS_AUTH_ONBOARDING} element={<AuthenticationAndOnboarding />} />
                        <Route path={paths.EVENTS_AI_GENERATION} element={<AiGenerationPage />} />
                        <Route path={paths.EVENTS_AI_TOOL_ACTIONS} element={<AiToolActionsPage />} />
                        <Route path={paths.EVENTS_AI_TOOLS} element={<AiToolsPage />} />
                        <Route path={paths.EVENTS_CONTENT} element={<ContentEventPage />} />
                        <Route path={paths.EVENTS_CONTENT_ENGAGEMENT} element={<ContentEngagementPage />} />
                        <Route path={paths.EVENTS_CREATOR} element={<CreatorPage />} />
                        <Route path={paths.EVENTS_DISCOVERY} element={<DiscoveryPage />} />
                        <Route path={paths.EVENTS_SEARCH} element={<SearchPage />} />
                        <Route path={paths.EVENTS_EDIT_SUITE} element={<EditSuitePage />} />
                        <Route path={paths.EVENTS_SUBSCRIPTION_REVENUE} element={<SubscriptionAndRevenueEventpage />} />
                        <Route path={paths.EVENTS_WALLET_REWARDS} element={<WalletAndRewardsPage />} />
                        <Route path={paths.EVENTS_NOTIFICATIONS} element={<NotificationsPage />} />
                        <Route path={paths.EVENTS_SETTINGS_PROFILE} element={<SettingsAndProfilePage />} />
                        <Route path={paths.EVENTS_DEVICE_PLATFORM} element={<DeviceAndPlatformPage />} />
                        <Route path={paths.EVENTS_DASHBOARD_NAVIGATION} element={<DashboardNavigationPage />} />
                        <Route path={paths.EVENTS_TOOL_WISE} element={<EventsPage />} />
                        <Route path={paths.EVENTS_OTHER_NAVIGATION} element={<EventsPage />} />

                        <Route path={paths.METRICS_DASHBOARD} element={<Navigate to={paths.METRICS_CORE_ENGAGEMENT} replace />} />
                        <Route path={paths.METRICS_CORE_ENGAGEMENT} element={<MatrixCoreEngagementPage />} />
                        <Route path={paths.METRICS_AI_GENERATION} element={<MatrixAiGenerationPage />} />
                        <Route path={paths.METRICS_CONTENT_ENGAGEMENT} element={<MatrixContentAndEngagementPage />} />
                        <Route path={paths.METRICS_CREATOR_ANALYTICS} element={<MatrixCreatorAnalyticsPage />} />
                        <Route path={paths.METRICS_SUBSCRIPTION_REVENUE} element={<MatrixSubscribtionAndRevenuePage />} />
                        <Route path={paths.METRICS_WALLET_REWARDS} element={<MatrixWalletAndRewardPage />} />
                        <Route path={paths.METRICS_AUTH_ONBOARDING} element={<MatrixAuthenticationAndOnboardingPage />} />
                        <Route path={paths.METRICS_NOTIFICATIONS_REENGAGEMENT} element={<MatrixNotificationsAndReengagementPage />} />









                      </Routes>

                    </Suspense>

                  </PersistGate>

                </Provider>

              </RouteContainer>

            </ContentContainer>

          </MainContainer>

        </PreviewProvider>

      </ImageDataProvider>

    </ContentProvider>

  );

};



export default RoutesComponent;

